import {
  Button,
  Container,
  Dimmer,
  Divider,
  Grid,
  Table,
  Loader,
  Segment,
  Item,
  Label,
  Modal,
  Header,
} from 'semantic-ui-react';

import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { Link } from 'react-router';
import { flashMessage, flashErrorMessage } from '../../actions/flash';
import { decodeSearch, encodeSearch } from '../../utils/url';
import Timestamp from '../../components/Timestamp';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import LoanAmount from '../../components/LoanAmount';
import CurrencySymbol from '../../components/CurrencySymbol';
import { fetchM } from '../../actions/fetchM';
import { isNumeric } from '../../utils/numbers/isNumber';
import { centsToFloat } from '../../utils/numbers/centsFloat';
import { getItem, setItem } from '../../utils/storage';
import valueToText from '../../utils/valueToText';
import config from '../../../config';


moment.locale('en-gb');

class OnlinePayments extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    return {
      currentPage,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = OnlinePayments.getPropsToState(props);
    state.data = [];
    this.state = {
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      ...state,
      autoReload: false,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: '',
      },
    };
    const query = decodeSearch(props.location.search);
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      this.state.advanceFilter = true;
    }
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchPayments(query);
    const localAutoReloadValue = getItem(`${config.get('appName')}.paymentsAutoReload`);
    if (localAutoReloadValue === 'true') {
      this.state.autoReload = true;
      this.setRefreshDataTimeout();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = OnlinePayments.getPropsToState(nextProps);
    const query = decodeSearch(nextProps.location.search);
    if (this.state.limit < 0) {
      this.fetchPayments(query);
      state.loading = this.state.loading;
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setPayments(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setRefreshDataTimeout = () => {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
    this.timeoutRefresh = setTimeout(() => {
      this.handleRefreshData();
      this.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  }
  getRowClassName = (status) => {
    if (status === 'payment_expired') {
      return 'row-colors payment_expired';
    }
    return '';
  }
  getPaymentStatus(data) {
    let onlinePaymentURL = '';
    if (data.requestStatus === 'payment_submitted' || data.requestStatus === 'payment_completed') {
      onlinePaymentURL = data.responsePaymentURL;
    }
    if (onlinePaymentURL !== '') {
      return (
        <div>
          <a href={data.responsePaymentURL} rel="noopener noreferrer" target="_blank">{valueToText(this.ONLINE_PAYMENT_STATUS, data.requestStatus)}</a><br />
        </div>
      );
    }
    return (
      <div>
        {valueToText(this.ONLINE_PAYMENT_STATUS, data.requestStatus)}<br />
      </div>
    );
  }
  async fetchPayments(q, silentLoad = false) {
    if (!silentLoad) {
      await this.setLoading(true);
    }
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumeric(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      const url = '/manage/payments/';
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setPayments(data);
      await this.setComponentState({
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  async approvePayment(err, paymentID) {
    err.preventDefault();
    await this.setLoading(true);
    const { store } = this.context;
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    await this.setComponentState({ modal });
    const query = decodeSearch(this.props.location.search);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/manage/payments/${paymentID}/approve/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      this.fetchPayments(query);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    }
    await store.dispatch(flashMessage({
      header: 'Payment Approved',
      message: 'MHub Pay request was successfully approved',
      icon: 'checkmark',
      type: 'success',
      autoHideDuration: 5000,
    }));
    await this.setLoading(false);
    this.fetchPayments(query);
  }
  async rejectPayment(err, paymentID) {
    err.preventDefault();
    await this.setLoading(true);
    const { store } = this.context;
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    await this.setComponentState({ modal });
    const query = decodeSearch(this.props.location.search);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/manage/payments/${paymentID}/reject/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    }
    await store.dispatch(flashMessage({
      header: 'Payment Rejected',
      message: 'MHub Pay request was successfully rejected',
      icon: 'x',
      type: 'success',
      autoHideDuration: 5000,
    }));
    await this.setLoading(false);
    this.fetchPayments(query);
  }
  hasStaffAccess() {
    if (this.props.auth.isBranchLeader) {
      return false;
    }
    return true;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.pushQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleRefreshData = () => {
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    query.page = 1;
    this.fetchPayments(query);
    store.dispatch(replace(`/payments/?${encodeSearch(query)}`));
  }
  handleAutoReload = () => {
    const autoReload = !this.state.autoReload;
    this.setState({ autoReload }, () => {
      setItem(`${config.get('appName')}.paymentsAutoReload`, autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        this.handleRefreshData();
        this.setRefreshDataTimeout();
      } else if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    });
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/payments/?${encodeSearch(query)}`));
    this.fetchPayments(query);
  }
  pushQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/payments/?${encodeSearch(query)}`));
    this.fetchPayments(query);
  }
  sortItems = [
    {
      text: 'Latest Payment',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Oldest Payment',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit.created_at',
      sortDirection: 'desc',
    },
    {
      text: 'Customer Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit.customer_name',
      sortDirection: 'asc',
    },
    {
      text: 'Customer Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit.customer_name',
      sortDirection: 'desc',
    },
  ];
  ONLINE_PAYMENT_STATUS = [
    { text: 'New Request', value: 'new' },
    { text: 'Approved', value: 'approved' },
    { text: 'Rejected', value: 'rejected' },
    { text: 'Payment Requested', value: 'payment_submitted' },
    { text: 'Payment Failed', value: 'payment_failed' },
    { text: 'Paid', value: 'payment_completed' },
    { text: 'Expired', value: 'payment_expired' },
  ];
  handleModalOnClose = (e) => {
    e.preventDefault();
    const modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: '',
    };
    this.setState({ modal });
  }
  handleModalOpen = (e, type, paymentID, bookingData) => {
    e.preventDefault();
    const modal = {
      isOpen: true,
      type,
      bookingData,
      paymentID,
    };
    this.setState({ modal });
  }
  hasExportAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasUserAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  render() {
    const { modal } = this.state;
    const exportItems = [
      {
        text: 'Excel',
        icon: 'download',
        href: `${config.get('bookApiURL')}/manage/payments/export/online/`,
      },
    ];
    return (
      <Container>
        <Modal
          basic
          open={modal.isOpen}
          onClose={this.handleModalOnClose}
        >
          <Header icon={modal.type === 'approve' ? 'check' : 'x'} content={modal.type === 'approve' ? 'Approve Payment' : 'Reject Payment'} />
          <Modal.Content>
            <Modal.Description>
              {modal.type === 'approve' &&
                <p>
                  Confirm Approve payment for&nbsp;
                  {modal.bookingData.projectUnit.reference}, <br className="large-hide" />{modal.bookingData.project.name}, <small>{modal.bookingData.code}</small>
                ?</p>
              }
              {modal.type === 'reject' &&
                <p>
                  <p>
                    Confirm Reject payment for&nbsp;
                    {modal.bookingData.projectUnit.reference}, <br className="large-hide" />{modal.bookingData.project.name}, <small>{modal.bookingData.code}</small>
                  ?</p>
                </p>
              }
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleModalOnClose} icon="cancel" content="No" />
            <Button
              positive={modal.type === 'approve'}
              negative={modal.type === 'reject'}
              onClick={(e) => {
                if (modal.type === 'approve') {
                  this.approvePayment(e, modal.paymentID);
                }
                if (modal.type === 'reject') {
                  this.rejectPayment(e, modal.paymentID);
                }
              }}
              icon="checkmark"
              content={modal.type === 'approve' ? 'Approve' : 'Reject'}
            />
          </Modal.Actions>
        </Modal>
        {/* <NavBar
          header={(this.state.count === 0) ? 'Online Payments' : <span>Payments &nbsp;<Label color="blue">{this.state.count}</Label></span>}
        /> */}
        <Divider hidden />
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column>
              {/* Search Filters */}
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                placeholder="Search Purchaser..."
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <div>
                    {this.hasExportAccess() &&
                      <SortButton
                        icon="download"
                        loading={this.state.loading}
                        items={exportItems}
                      />
                    }
                    <SortButton
                      loading={this.state.loading}
                      items={this.sortItems}
                      onSort={this.handleSortData}
                    />
                  </div>
                )}
              />
            </Grid.Column>
          </Grid.Row>
          {/* List Data */}
          <Grid.Row className="app--listdata">
            <Grid.Column>
              <br className="large-hide" />
              <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              <Grid>
                <Grid.Row>
                  <Grid.Column textAlign="center" width={16}>
                    <Button
                      onClick={this.handleAutoReload}
                      compact
                      size="tiny"
                      icon={this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' }}
                      content={`Auto Refresh ${this.state.autoReload ? 'On' : 'Off'}`}
                    />
                    <Button
                      color="blue"
                      onClick={this.handleRefreshData}
                      compact
                      size="tiny"
                      icon="refresh"
                      content="Refresh Now"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {
                this.state.data && this.state.data.length > 0 ?
                  <Grid columns={2} className="equal height">
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Table celled collapsing className="online-payments">
                          { this.state.data.length > 0 ?
                            <Table.Header className="mobile-hide">
                              <Table.Row>
                                <Table.HeaderCell>Booking</Table.HeaderCell>
                                <Table.HeaderCell>Purchaser</Table.HeaderCell>
                                <Table.HeaderCell>Amount</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">Requester</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">Status</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">Manage</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            : null
                          }
                          <Table.Body>
                            { this.state.data && this.state.data.length > 0 ?
                              this.state.data.map((data, idx) => (
                                <Table.Row
                                  key={idx}
                                  id={data.id}
                                  positive={data.requestStatus === 'payment_completed'}
                                  negative={data.requestStatus === 'payment_failed' || data.requestStatus === 'rejected'}
                                  className={this.getRowClassName(data.requestStatus)}
                                >
                                  <Table.Cell collapsing>
                                    <Link to={`/bookings/${data.booking.id}/`} style={{ whiteSpace: 'normal' }}>
                                      {data.requestStatus === 'new' ?
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          color="green"
                                          onClick={e => this.approvePayment(e, data.id)}
                                          size="mini"
                                          compact
                                        >
                                          Approve
                                        </Button>
                                        : null
                                      }
                                      {data.requestStatus === 'new' ?
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          color="red"
                                          onClick={e => this.rejectPayment(e, data.id)}
                                          size="mini"
                                          compact
                                        >
                                          Reject
                                        </Button>
                                        : null
                                      }
                                      {data.booking.projectUnit.reference}
                                      , <br className="large-hide" />
                                      {data.booking.project.name}
                                      , <br />
                                      <small>{data.booking.code}</small>
                                    </Link>
                                  </Table.Cell>
                                  <Table.Cell collapsing className="mobile-hide">
                                    {data.customerName}
                                  </Table.Cell>
                                  <Table.Cell collapsing className="mobile-hide">
                                    <LoanAmount
                                      format="0,000,000.00"
                                      amount={centsToFloat(data.amountCents)}
                                      prefix={<CurrencySymbol />}
                                    />
                                  </Table.Cell>
                                  <Table.Cell collapsing textAlign="right">
                                    <span className="large-hide small-hide tablet-hide" style={{ float: 'left' }}>
                                      {data.customerName}
                                    </span>
                                    <i>
                                      <small>
                                        <span>by </span>
                                        {
                                          this.hasUserAccess() ?
                                            <Link to={`/users/${data.requestedAffID}/`} >
                                              {data.requestedName}
                                            </Link>
                                            : data.requestedName
                                        }
                                        <span className="large-hide small-hide tablet-hide">,&nbsp;</span><br className="mobile-hide" />
                                        <Timestamp
                                          timestamp={data.createdAt}
                                          precise
                                        />
                                      </small>
                                    </i>
                                  </Table.Cell>
                                  <Table.Cell collapsing textAlign="right">
                                    <span className="large-hide small-hide tablet-hide" style={{ float: 'left' }}>
                                      <LoanAmount
                                        format="0,000,000.00"
                                        amount={centsToFloat(data.amountCents)}
                                        prefix={<CurrencySymbol />}
                                      />
                                    </span>
                                    {this.getPaymentStatus(data)}
                                  </Table.Cell>
                                  <Table.Cell collapsing textAlign="right">
                                    {data.requestStatus === 'new' ?
                                      <Button className="mobile-hide" color="green" onClick={e => this.handleModalOpen(e, 'approve', data.id, data.booking)}>Approve</Button>
                                      : null
                                    }
                                    {data.requestStatus === 'new' ?
                                      <Button className="mobile-hide" color="red" onClick={e => this.handleModalOpen(e, 'reject', data.id, data.booking)}>Reject</Button>
                                      : null
                                    }
                                    {data.approvedName !== '' ?
                                      <span>Approved by&nbsp;
                                        {
                                          this.hasUserAccess() ?
                                            <Link to={`/users/${data.approvedAffID}/`} >
                                              {data.approvedName}
                                            </Link>
                                            : data.approvedName
                                        }
                                      </span>
                                      : null
                                    }
                                    {data.requestStatus === 'rejected' ?
                                      'Rejected'
                                      : null
                                    }
                                  </Table.Cell>
                                </Table.Row>
                              ))
                              : null
                            }
                          </Table.Body>
                        </Table>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item style={{}}>
                            <Item.Content>
                              {
                              !this.state.loading ?
                                <Segment textAlign="center">
                                  <p>No payments found.</p>
                                </Segment>
                              : ''
                              }
                            </Item.Content>
                          </Item>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )
                }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(OnlinePayments.mapStateToProps)(OnlinePayments);



// WEBPACK FOOTER //
// ./src/containers/Payments/OnlinePayments.jsx